import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import pinia from './stores/pinia'
import { initSentry } from './services/sentry'
import './assets/main.css'

const PRELOAD_RELOAD_SESSION_KEY = 'flowestudio:chunk-reload-path'

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()

  const targetPath = `${window.location.pathname}${window.location.search}${window.location.hash}`
  const alreadyReloaded = sessionStorage.getItem(PRELOAD_RELOAD_SESSION_KEY) === targetPath
  if (alreadyReloaded) return

  sessionStorage.setItem(PRELOAD_RELOAD_SESSION_KEY, targetPath)
  window.location.assign(targetPath)
})

const app = createApp(App)

app.use(pinia)
app.use(router)

// Sentry debe inicializarse después de pinia y router, antes de mount
initSentry(app, router)

app.mount('#app')
